import {
  ProgressSection,
  ProgressLabel,
  ProgressTrack,
  ProgressFill,
} from '../MembersPageStyles'

export function MembersProgressBar({ completed = 0, maxCompleted = 1 }) {
  const safeMax = Math.max(1, Number(maxCompleted) || 1)
  const safeCompleted = Math.min(Number(completed) || 0, safeMax)
  const pct = Math.round((safeCompleted / safeMax) * 100)

  return (
    <ProgressSection>
      <ProgressLabel>
        <span>Membership usage</span>
        <span>
          {safeCompleted} / {safeMax} seats
        </span>
      </ProgressLabel>
      <ProgressTrack>
        <ProgressFill style={{ width: `${pct}%` }} />
      </ProgressTrack>
    </ProgressSection>
  )
}
